import { IUser } from "@/types";

export const FHIR_PRACTITIONER_ID_KEY = "fhir-practitioner-id";
export const FHIR_PRACTITIONER_NAME_KEY = "fhir-practitioner-name";
export const FHIR_PRACTITIONER_EMAIL_KEY = "fhir-practitioner-email";
export const FHIR_CARE_TEAMS_KEY = "fhir-care-teams";

export const isOrgAdmin = (user?: IUser | null): boolean => {
  return user?.roles?.includes("OrgAdmin") ?? false;
};

/**
 * Returns the practitioner's featuresv2 permission strings from a raw user record value.
 */
export const getFeaturesV2 = (raw: unknown): string[] => {
  if (!Array.isArray(raw)) {
    return [];
  }
  const features = raw.filter((entry): entry is string => typeof entry === "string" && entry !== "");
  return Array.from(new Set(features));
};

/**
 * Validates that all required environment variables are set for the application to function properly
 * @returns {boolean} true if all required variables are set, false otherwise
 */
export function validateEnvironmentVariables(): boolean {
  console.log("🔍 Validating environment configuration...");

  const requiredVariables = {
    // FHIR R4 Server Configuration
    VITE_FHIR_BASE_URL: import.meta.env.VITE_FHIR_BASE_URL,

    // Authentication Configuration
    VITE_AUTH_BASE_URL: import.meta.env.VITE_AUTH_BASE_URL,

    // Medly REST API
    VITE_MEDLY_BASE_URL: import.meta.env.VITE_MEDLY_BASE_URL,
  };

  const missing: string[] = [];
  const present: string[] = [];

  Object.entries(requiredVariables).forEach(([key, value]) => {
    if (!value || value.trim() === "") {
      missing.push(key);
    } else {
      present.push(key);
    }
  });

  // Log present variables (for debugging)
  if (present.length > 0) {
    console.log("✅ Environment variables configured:", present.join(", "));
  }

  // Report missing variables
  if (missing.length > 0) {
    console.error("❌ Missing required environment variables:");
    missing.forEach(key => {
      console.error(`  - ${key}`);
    });
    console.error("");
    console.error("🔧 To fix this:");
    console.error("  1. Copy .env.example to .env");
    console.error("  2. Fill in all the required values in your .env file");
    console.error("  3. Restart the development server");
    console.error("");
    console.error("📋 See .env.example for detailed configuration instructions");
    return false;
  }

  console.log("✅ All required environment variables are configured");
  return true;
}
